// eslint-disable-next-line import/prefer-default-export
export const SEPARATE_MODE_AND_SLEEP_PRODUCTS = [
  "kajnukffs6appels",
  "bd4ztozj4aied1ps",
];
